import { lazy,Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import SuspenseLoader from 'cui/components/SuspenseLoader';
import RouteAuth from 'RouteAuth';
import { Applications } from './pages/admin/applications/Applications';
import PageNotFound from './pages/pageNotFound/PageNotFound';
import { RoutePaths } from './utils/RoutePaths';
import { ApplicationLevelAdminWorkspacePermission, SystemAdminWorkspacePermission } from 'utils/users';

const Loader = (Component: any) => (props: any) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

  const Workspaces = Loader(lazy(() => import('pages/admin/workspaces/Workspaces')));
  const Reports = Loader(lazy(() => import('pages/admin/reports/Reports')));
  const ReportAudit = Loader(lazy(() => import('pages/admin/audits/ReportAudit')));
  const SystemAudit = Loader(lazy(() => import('pages/admin/audits/SystemAudit')));

  const ReportDetails = Loader(lazy(() => import('pages/users/reports/ReportDetails')));
  const ReportFullScreen = Loader(lazy(() => import('pages/users/reports/ReportFullScreen')));
  const ApplicationsDashboard = Loader(lazy(() => import('pages/users/application/ApplicationsDashboard')));
  const ClientReportsDashboard = Loader(lazy(() => import('pages/users/gallery/ClientReportsDashboard')));
  const UserReportsDashboard = Loader(lazy(() => import('pages/users/gallery/UserReportsDashboard')));
  const ClientAdminReportsAudit = Loader(lazy(() => import('pages/admin/audits/ClientAdminReport')));
  const UserReportsAudit = Loader(lazy(() => import('pages/admin/audits/UserReportsAudit')));
  const SharedReportMapper = Loader(lazy(() => import('pages/users/reports/SharedReportMapper')));
  

  export const routerConfig = [
    {
      element: <RouteAuth element={<Workspaces />} requiredFeatures={[SystemAdminWorkspacePermission, ApplicationLevelAdminWorkspacePermission]} />,
      path: RoutePaths.Admin.Workspaces
    },
    {
      element: <RouteAuth element={<Reports />} requiredFeatures={[SystemAdminWorkspacePermission, ApplicationLevelAdminWorkspacePermission]} />,
      path: `${RoutePaths.Admin.Workspaces}/:id`,
    },
    {
      element: <RouteAuth element={<Applications />} requiredFeatures={[SystemAdminWorkspacePermission]} />,
      path: RoutePaths.Admin.Applications,
    },
    {
      element: <RouteAuth element={<ReportAudit />} requiredFeatures={[SystemAdminWorkspacePermission, ApplicationLevelAdminWorkspacePermission]} />,
      path: RoutePaths.Admin.ReportAudit
    },
    {
      element: <RouteAuth element={<SystemAudit />} requiredFeatures={[SystemAdminWorkspacePermission]} />,
      path: RoutePaths.Admin.SystemAudit
    },
    {
      element: <ReportDetails />,
      path: `:applicationName/${RoutePaths.User.Reports}:workspaceId/:reportId`,
    },
    {
      element: <ReportFullScreen />,
      path: RoutePaths.User.ReportsFullScreen,
    },
    {
      element: <SharedReportMapper />,
      path:`${RoutePaths.User.SharedReport}:code`,
    },
    {
      element: <ApplicationsDashboard />,
      path: RoutePaths.User.Applications,
    },
    {
      element: <ClientReportsDashboard />,
      //path: `${RoutePaths.User.Applications}/:applicationId/:clientId`,
      path: `${RoutePaths.User.Applications}/:applicationId/:clientId/:engagementId`,
    },
    {
      element: <UserReportsDashboard />,
      path: `${RoutePaths.User.Applications}/:applicationId`,
    },
    {
      element: <ClientAdminReportsAudit />,
      path: `${RoutePaths.Admin.ClientAdmitReportAudit}/:applicationId/:clientId`,
    },
    {
      element: <UserReportsAudit />,
      path: `${RoutePaths.Admin.UserReportsAudit}/:applicationId`,
    },
    {
      element: <Navigate  to={RoutePaths.User.Applications} replace />,
      path: RoutePaths.Home,
    },
    {
      element: <PageNotFound />,
      path: RoutePaths.DefaultRedirect,
    },
  ];